export default function Marquee({ items }) {
  const doubled = [...items, ...items, ...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-[rgba(212,175,55,0.15)] bg-[#0D0F12] py-5">
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-2xl italic text-neutral-500">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-[#D4AF37]" />
          </span>
        ))}
      </div>
    </div>
  );
}
